<template>
    <div class="editor-cog-wrapper" v-if="editorEnabled">
        <div style="display: flex; flex-basis: content;" :title="unsavedConfig ? 'Unsaved Changes' : 'Open Settings'">
            <div class="editor-cog-button" @click="getEditor({cId: componentId, toggle: true, previewId})">
                <span class="e-icons e-cog edit-settings"></span>
            </div>
            <div v-show="unsavedConfig" class="other-info">!</div>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

const settingsCogComponent = {
    name: 'settingsCog',
    props: {
        componentId: {
            default: false
        },
        testMode: {
            default: false
        },
        editorEnabled: {
            default: false
        },
        previewId: {
            default: false
        },
        unsavedConfig: {
            default: false
        }
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions({
            getEditor: 'settingsEditorStore/getEditor'
        })
    }
};

export default settingsCogComponent;
</script>

<style lang="css">
.edit-settings {
    margin-bottom: -3px;
}
.component-settings-editor .e-icons.e-cog:before {
    content: '\e679' !important;
}
.editor-cog-wrapper {
    position: relative;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    display: flex;
    overflow: visible;
    z-index: 1100;
}
.editor-cog-button {
    height: 22px;
    width: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    background-color: #dfd9d0;
    border-radius: 50%;
    cursor: pointer;
    padding-bottom: 4px;
    z-index: 1;
    border: 1px solid #bbb;
    box-shadow: -1px -1px 2px rgb(0 0 0 / 10%);
}
.editor-cog-button:hover {
    background-color: #e7e1d8;
}
.editor-cog-button:active {
    background-color: #d8d1c9;
}
.other-info {
    width: 26px;
    height: 20px;
    top: 1px;
    position: relative;
    left: -11px;
    padding-left: 15px;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    background-color: #e55871;
    color: white;
    box-shadow: 1px 1px 3px rgba(0,0,0, 0.15) inset;
    border-bottom: 1px solid #f6a1b0;
    border-radius: 0 10px 10px 0;
    transition: width .3s ease-out;
    cursor: pointer;
}
</style>
